import Link from 'next/link'

import type { FooterLink } from '@/types/contentful/footerType'

export const FooterLinks = ({ heading, links }: { heading?: string; links: FooterLink[] }) => {
  if (!links?.length) return null

  return (
    <div className="max-w-44">
      {heading && <h2 className="mb-3 text-base font-semibold text-primary-900">{heading}</h2>}{' '}
      <ul className="grid gap-y-2">
        {links?.map(({ fields }, index) => {
          const label = fields?.label
          const url = fields?.url
          if (label && url)
            return (
              <li key={`${index}${label}`}>
                <Link className="text-base not-italic text-grey-700" href={url}>
                  {label}
                </Link>
              </li>
            )
        })}
      </ul>
    </div>
  )
}
